var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 67,
    viewBox: "0 0 54 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 66.8205H29.4836L54 42.3041V0H0V66.8205Z",
    fill: "url(#paint0_linear_338_3733)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M0 51.8362V66.8235H29.4836L54 42.3072V21.1931C42.6811 39.2501 22.7772 51.3737 0 51.8362Z",
    fill: "#840977",
    fillOpacity: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4834 42.3044H53.9998L29.4834 66.8208V42.3044Z",
    fill: "url(#paint1_linear_338_3733)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3235 7.44751L17.7581 13.5263L28.3235 19.605L38.8889 13.5263L28.3235 7.44751Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7317 27.8907L26.4419 34.0782V21.74L15.7317 15.5525V27.8907Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7578 34.0782L39.468 27.8907V15.5525L28.7578 21.74V34.0782Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_338_3733",
    x1: -15.73,
    y1: 85.1547,
    x2: 45.7584,
    y2: -6.94615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC15E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68003E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_338_3733",
    x1: 8.65233,
    y1: 91.6417,
    x2: 38.2089,
    y2: 47.5707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B53D88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E433A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLogo);
export default __webpack_public_path__ + "static/media/fileLogo.03baf478d42f47999df5fd837bb2707a.svg";
export { ForwardRef as ReactComponent };